import {UserMetricInstance} from "./UserMetricInstance";
import {TypeOfDateSettingsEnumCharts} from "../../../enums/dashboard/TypeOfDateSettingsEnumCharts";
import {TimeUnitEnum} from "../../../enums/dashboard/TimeUnitEnum";
import {UserMetricGroupDetailCB} from "../../../ope/user/metric/GetUserMetricGroupCB";
import {BucketUnitEnum} from "../../../enums/dashboard/ChartsEnum";

export class UserMetricGroup {
  id!: number;
  widgetId?: string;
  name!: string;
  bucketUnits: BucketUnitEnum;
  bucketValue: number;
  metrics?: UserMetricInstance[];

  startDate: any;
  endDate: any;
  selectedDateSettings: TypeOfDateSettingsEnumCharts;
  realTimeUnit: TimeUnitEnum;
  realtimeValue: number;

  // Either getUserMetricGroup or its impersonation-aware variant: same payload, and the chart page
  // uses whichever matches the user whose charts are on screen
  constructor(getUserMetricGroupCB?: UserMetricGroupDetailCB) {
    if (!getUserMetricGroupCB) {
      this.metrics = [];
      this.bucketUnits = BucketUnitEnum.HOURS;
      this.bucketValue = 1;
      this.startDate = new Date().getTime();
      this.endDate = new Date().getTime();
      this.selectedDateSettings = TypeOfDateSettingsEnumCharts.REALTIME;
      this.realTimeUnit = TimeUnitEnum.DAYS;
      this.realtimeValue = 1;
    } else {
      this.metrics = [];
      getUserMetricGroupCB.o.metrics.forEach(mi => {
        let newML = new UserMetricInstance;
        newML.partitionId = mi.metricInstance.partitionId;
        newML.partitionName = mi.metricInstance.partitionName;
        newML.deviceId = mi.metricInstance.deviceId;
        newML.deviceName = mi.metricInstance.deviceName;
        newML.id = mi.metricInstance.id;
        newML.type = mi.metricInstance.type;
        newML.name = mi.metricInstance.name;
        newML.dataTypeGroup = mi.metricInstance.dataTypeGroup;
        newML.dataUnit = mi.metricInstance.dataUnit;
        newML.color = mi.color;
        newML.chartType = mi.chartType;
        newML.functionType = mi.functionType;
        newML.alias = mi.uniqueCode;
        newML.decimalDigits = mi.metricInstance.decimalDigits;
        newML.lastValue = mi.metricInstance.lastValue;
        newML.lastValueTs = mi.metricInstance.lastValueTs;
        newML.dataTypeGroupShowAsHex = mi.metricInstance.dataTypeGroupShowAsHex;
        this.metrics!.push(newML)
      });
      this.id = getUserMetricGroupCB.o.id;
      this.name = getUserMetricGroupCB.o.name;
      this.bucketUnits = getUserMetricGroupCB.o.bucketUnits;
      this.bucketValue = getUserMetricGroupCB.o.bucketValue;
      this.startDate = getUserMetricGroupCB.o.timeInterval.startDate;
      this.endDate = getUserMetricGroupCB.o.timeInterval.endDate;
      this.selectedDateSettings = getUserMetricGroupCB.o.timeInterval.selectedDateSettings;
      this.realTimeUnit = getUserMetricGroupCB.o.timeInterval.realTimeUnit;
      this.realtimeValue = getUserMetricGroupCB.o.timeInterval.realtimeValue;
    }
  }
}
